import React, { useState } from "react"
import { Tabs } from "antd"
import FormComponents from "../Form"

const { TabPane } = Tabs

const TabsComponents = (props) => {
  const { form } = props
  const [tabActiveKey, setTabActiveKey] = useState("information")

  const tabsPane = [
    {
      key: "information",
      title: "Información",
      content: <FormComponents {...props} formData={form} />,
      active: true,
    },
    {
      key: "dimension",
      title: "Dimensiones",
      content: <div>Not Form!</div>,
      active: false,
    },
  ]

  const changeTabs = (key) => {
    setTabActiveKey(key)
  }

  return (
    <div>
      <Tabs activeKey={tabActiveKey} onChange={changeTabs} animated={false}>
        {tabsPane
          .filter((item) => item.active)
          .map((item) => (
            <TabPane tab={item.title} key={item.key} forceRender>
              {item.content}
            </TabPane>
          ))}
      </Tabs>
    </div>
  )
}

TabsComponents.propTypes = {}

export default TabsComponents
